import { render } from "./OfferCard.vue?vue&type=template&id=00044fad&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=js"
export * from "./OfferCard.vue?vue&type=script&lang=js"

import "./OfferCard.vue?vue&type=style&index=0&id=00044fad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00044fad"]])

export default __exports__